import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

const getDefaultState = () => ({
  EmailID: "",
  Phone_Number: "",
  image_url: "",
  getPreviousRoute: "",
  MotoristName: {},
  CarDetails: {},
  Authentication: false,
  MotoristBoolean: true,
  isSubscribed: false,
  view_motorist_profile: false,
  current_location: true,
  current_chat_id: "",

  getIssueDetails: {},
  currentFormObject: {},
  currentRouteObject: {},
  ChatListings: {},
  CompleteData: {},

  GetCurrentUser: {},
  GetCurrentOrg: [],
  GetTeamList: [],

  Enabled_Location: false,
  audioAutoPlay: true,

  chatNotification: { status: false },
  videocall: { status: false },

  messages: [],
});

export default createStore({
  // state: {
  //   EmailID: "",
  //   Phone_Number: "",
  //   image_url: "",
  //   getPreviousRoute: "",
  //   MotoristName: {},
  //   CarDetails: {},
  //   Authentication: false,
  //   MotoristBoolean: true,
  //   isSubscribed: false,
  //   view_motorist_profile: false,
  //   current_location: true,
  //   current_chat_id: "",

  //   getIssueDetails: {},
  //   currentFormObject: {},
  //   currentRouteObject: {},
  //   ChatListings: {},
  //   CompleteData: {},

  //   GetCurrentUser: {},
  //   GetCurrentOrg: [],
  //   GetTeamList: [],

  //   Enabled_Location: false,
  //   audioAutoPlay: true,

  //   chatNotification: { status: false },
  //   videocall: { status: false },

  //   messages: [],
  // },
  state: getDefaultState(),

  getters: {
    get_auth: (state) => state.Authentication,
    get_user_email: (state) => state.EmailID,
    get_phone_number: (state) => state.Phone_Number,
    get_current_user_details: (state) => state.GetCurrentUser,
    get_motorist_name: (state) => state.MotoristName,
    get_car_details: (state) => state.CarDetails,
    get_chat_list: (state) => state.ChatListings,
    get_motorist_again: (state) => state.MotoristBoolean,
    get_subscription_status: (state) => state.isSubscribed,
    get_chat_id: (state) => state.current_chat_id,
    get_motorist_boolean: (state) => state.view_motorist_profile,
    get_current_location: (state) => state.current_location,
    get_complete_data: (state) => state.CompleteData,
    get_location_enabled: (state) => state.Enabled_Location,
    get_audio_autoplay: (state) => state.audioAutoPlay,
    get_chat_notification: (state) => state.chatNotification.status,
    get_all_messages: (state) => {
      return [...state.messages].sort(
        (a, b) => new Date(a.message_sent_on) - new Date(b.message_sent_on),
      );
    },
    get_videocall_notification: (state) => state.videocall.status,
    get_activity_type: (state) => {
      return state.Activity_Type;
    },
  },

  mutations: {
    SET_AUTH(state, val) {
      state.Authentication = val;
    },
    SET_USEREMAIL(state, val) {
      state.EmailID = val;
    },
    SET_PHONENUMBER(state, val) {
      state.Phone_Number = val;
    },
    SET_CURRENTUSER_DETAILS(state, val) {
      state.GetCurrentUser = val;
    },
    SET_MOTORIST_NAME(state, val) {
      state.MotoristName = val;
    },
    SET_CAR_DETAILS(state, val) {
      state.CarDetails = val;
    },
    SET_CHAT_LIST(state, val) {
      state.ChatListings = val;
    },
    SET_MOTORIST_AGAIN(state, val) {
      state.MotoristBoolean = val;
    },
    SET_SUBSCRIPTION_STATUS(state, val) {
      state.isSubscribed = val;
    },
    SET_CHAT_ID(state, val) {
      state.current_chat_id = val;
    },
    SET_MOTORIST_BOOLEAN(state, val) {
      state.view_motorist_profile = val;
    },
    SET_CURRENT_LOCATION(state, val) {
      state.current_location = val;
    },
    // SET_COMPLETE_DATA(state, val) {
    //   state.CompleteData =
    //     Object.keys(val).length === 0 ? {} : { ...state.CompleteData, ...val };
    // },
    SET_COMPLETE_DATA(state, CompleteData) {
      if (Object.keys(CompleteData).length === 0) {
        state.CompleteData = {};
      } else {
        state.CompleteData = {
          ...state.CompleteData,
          ...CompleteData,
        };
      }
    },
    SET_LOCATION_ENABLED(state, val) {
      state.Enabled_Location = val;
    },
    SET_AUDIO_AUTOPLAY(state, val) {
      state.audioAutoPlay = val;
    },
    SET_CHAT_NOTIFICATION(state, status) {
      state.chatNotification = { status };
    },
    ADD_NEW_MESSAGE(state, message) {
      if (!Array.isArray(state.messages)) {
        state.messages = [];
      }
      const messageObject = {
        text: message,
        message_sent_on: new Date().toISOString(),
      };

      state.messages = [...state.messages, messageObject].sort(
        (a, b) => new Date(a.message_sent_on) - new Date(b.message_sent_on),
      );
    },

    SET_VIDEO_CALL_NOTIFICATION(state, status) {
      state.videocall = { status };
    },
    SET_ACTIVITY_TYPE(state, Activity_Type) {
      state.Activity_Type = Activity_Type;
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState());
    },
  },

  actions: {
    clearMotoristAndCarDetails({ commit }) {
      commit("RESET_STATE");
      localStorage.removeItem("vuex");
    },
  },

  plugins: [createPersistedState()],
});
